/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

import styles from "assets/scss/emtay.module.scss";

function FeaturesOne() {
  return (
    <MKBox component="section" py={{ xs: 3, md: 4 }}>
      <Container>
        <Grid container alignItems="center">
          <Grid item xs={12} lg={5}>
            <MKTypography variant="h3" my={1}>
              Wij zorgen dat techniek waarde oplevert.
            </MKTypography>
            <MKTypography variant="body2" color="text" mb={2}>
              Of het nu gaat om software die klopt, projecten die wél van de grond komen, of mensen
              die echt passen — wij versterken jouw organisatie daar waar technologie het verschil
              moet maken. We bouwen mee aan digitale oplossingen die werken én blijven werken.
              Altijd samen met jouw team, altijd met oog voor het grotere geheel.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
            <Stack className={styles.servicesBlock}>
              <MKBox display="flex" alignItems="center" p={2}>
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor="info"
                  color="white"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  className={styles.iconBox}
                >
                  <Icon fontSize="small">code</Icon>
                </MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  <span className={styles.serviceTitle}>Full-on software development</span>
                  <br />
                  samen met jouw teams / organisatie, op projectbasis
                </MKTypography>
              </MKBox>
              <MKBox display="flex" alignItems="center" p={2}>
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor="info"
                  color="white"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  className={styles.iconBox}
                >
                  <Icon fontSize="small">settings_overscan</Icon>
                </MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  <span className={styles.serviceTitle}>Project feasibility audits</span>
                  <br />
                  Uw &lsquo;second opinion&rsquo;, al vanaf &euro; 1495,- ex btw.
                </MKTypography>
              </MKBox>
              <MKBox display="flex" alignItems="center" p={2}>
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor="info"
                  color="white"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  className={styles.iconBox}
                >
                  <Icon fontSize="small">interpreter_mode</Icon>
                </MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  <span className={styles.serviceTitle}>Technical screening services</span>
                  <br />
                  Hulp bij het maken van de juiste hires voor jouw organisatie
                </MKTypography>
              </MKBox>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FeaturesOne;
